export const SITE_ORIGIN = 'https://business-calculator-kr.pages.dev';
export const SITE_NAME = '비즈니스 레이더 KR';
export const SITE_DESCRIPTION =
  '공고·지원사업·상권 경쟁현황을 확인하고 검토 큐와 수익성·가격·손익·광고 판단까지 이어가는 비즈니스 의사결정 도구입니다. 청약정보는 별도 생활·자산 Radar로 제공합니다.';

export const WORKSPACE_SEO = {
  title: '비즈니스 레이더 KR | 사업기회·상권·수익성 도구',
  description: SITE_DESCRIPTION,
  canonicalPath: '/',
  robots: 'index,follow',
} as const;

export const INBOX_SEO = {
  title: '검토 큐 | 저장한 정보 진행상태 관리',
  description: '이 브라우저에서 저장한 청약정보·공고·지원사업·상권 경쟁현황을 관심·검토중·준비중·완료·보류 단계로 이어서 관리합니다.',
  canonicalPath: '/inbox',
  robots: 'noindex,follow',
} as const;

export const HOUSING_SEO = {
  title: '청약정보 레이더 | 청약홈 분양·무순위·임대 일정',
  description: '청약홈 공식 분양정보를 지역·공급유형·접수 마감 기준으로 정리하고 NEW·관심 기준으로 반복 확인합니다.',
  canonicalPath: '/radar/housing',
  robots: 'index,follow',
} as const;

export const HOME_SEO = {
  title: '공고·입찰 레이더 | 비즈니스 레이더 KR',
  description: '나라장터 사업기회를 NEW·마감·관심 기준으로 선별하고 반복 확인할 수 있는 공고·입찰 레이더입니다.',
  canonicalPath: '/radar/bids',
  robots: 'index,follow',
} as const;

export const SUPPORT_SEO = {
  title: '지원사업 레이더 | 내 조건에 맞는 사업지원 정보',
  description: '지역·분야별 지원사업을 NEW·마감·관심 기준으로 선별해 반복 확인하는 지원사업 레이더입니다.',
  canonicalPath: '/radar/support',
  robots: 'index,follow',
} as const;

export const COMMERCIAL_SEO = {
  title: '상권 경쟁현황 레이더 | 지역·업종별 점포 밀도와 경쟁강도',
  description: '소상공인시장진흥공단 상가(상권)정보를 바탕으로 후보 지역의 점포 밀도와 동종업종 비중을 확인합니다.',
  canonicalPath: '/radar/commercial-areas',
  robots: 'index,follow',
} as const;

export const SITES_SEO = {
  title: '신규현장 레이더 | 기존 링크 호환 페이지',
  description: '기존 신규현장 링크 호환을 위해 유지되는 페이지입니다. 현재 주력 탐색 기능은 공고·입찰과 상권 레이더입니다.',
  canonicalPath: '/radar/sites',
  robots: 'noindex,follow',
} as const;

export const TOOL_SEO = {
  profitability: { title: '수익성 분석 | 매출·비용·이익·마진 통합 시뮬레이터', description: '매출과 직접원가, 변동비, 고정비, 광고비를 연결해 실제 이익과 순이익률을 확인합니다.', canonicalPath: '/tools/profitability', robots: 'index,follow' },
  pricing: { title: '가격·견적 | 목표마진 판매가·할인 판단 도구', description: '단위원가, 기타비용, 수수료와 목표마진을 기준으로 적정 판매가와 할인 후 이익을 확인합니다.', canonicalPath: '/tools/pricing', robots: 'index,follow' },
  planning: { title: '손익·현금흐름 | BEP·목표이익·런웨이 플래너', description: '판매량과 고정비, 보유현금을 조정해 손익분기 판매량, 목표이익 판매량과 현금 런웨이를 확인합니다.', canonicalPath: '/tools/planning', robots: 'index,follow' },
  growth: { title: '광고·성장 | ROAS·손익분기 광고비 시뮬레이터', description: '광고비, 광고 기여매출, 마진율을 연결해 현재 ROAS와 손익분기 ROAS, 최대 광고비와 목표매출을 확인합니다.', canonicalPath: '/tools/growth', robots: 'index,follow' },
} as const;

export const CALCULATORS_SEO = {
  title: '사업 계산기 | 가격·마진·손익·세금·광고 계산도구',
  description: '가격, 마진, 손익, 세금 기초, 광고비 의사결정에 필요한 사업 계산기 10종을 제공합니다.',
  canonicalPath: '/calculators',
  robots: 'index,follow',
} as const;

export const NOT_FOUND_SEO = {
  title: '페이지를 찾을 수 없습니다 | 비즈니스 레이더',
  description: '요청한 페이지를 찾을 수 없습니다.',
  canonicalPath: '/404',
  robots: 'noindex,follow',
} as const;

export const PRODUCT_ROUTES = [
  HOUSING_SEO.canonicalPath,
  HOME_SEO.canonicalPath,
  SUPPORT_SEO.canonicalPath,
  COMMERCIAL_SEO.canonicalPath,
  TOOL_SEO.profitability.canonicalPath,
  TOOL_SEO.pricing.canonicalPath,
  TOOL_SEO.planning.canonicalPath,
  TOOL_SEO.growth.canonicalPath,
] as const;

export function absoluteUrl(pathname: string): string {
  return new URL(pathname, `${SITE_ORIGIN}/`).toString();
}
